import { PlusOutlined, ShopOutlined } from '@ant-design/icons';
import { useAccess, useIntl } from '@umijs/max';
import { Button, Empty, Typography } from 'antd';

const { Text } = Typography;

interface EmptyMerchantsProps {
  onCreateMerchant?: () => void;
}

const EmptyMerchants: React.FC<EmptyMerchantsProps> = ({
  onCreateMerchant,
}) => {
  const intl = useIntl();
  const access = useAccess();

  return (
    <Empty
      image={<ShopOutlined style={{ fontSize: 64, color: '#d9d9d9' }} />}
      description={
        <div>
          <Text type="secondary" style={{ fontSize: 16 }}>
            {intl.formatMessage({ id: 'components.emptyMerchants.title' })}
          </Text>
          <br />
          <Text type="secondary">
            {intl.formatMessage({
              id: 'components.emptyMerchants.description',
            })}
          </Text>
        </div>
      }
      style={{ padding: '60px 0' }}
    >
      {access.canCreateAccountHolder && onCreateMerchant && (
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={onCreateMerchant}
        >
          {intl.formatMessage({ id: 'components.emptyMerchants.createButton' })}
        </Button>
      )}
    </Empty>
  );
};

export default EmptyMerchants;
